<template>
  <div id="home" class="dx-theme-accent-as-background-color">
    <div class="login-form">
      <router-link to="/backoffice">
        <img src="../assets/logo.svg" alt="PagoUno Logo"> 
      </router-link>
      <!-- 
        -- ToDo
        -- Login que redireccion a la vista BackOffice.vue
       -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
}
</script>

<style>
  #home {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .login-form img{
    height: 150px;
  }
</style>
